"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressDetailsPanelCms = void 0;
var AddressDetailsPanelCms = /** @class */ (function () {
    function AddressDetailsPanelCms() {
        this.shippingAddressTitleLabel = 'Shipping address';
        this.serviceAddressTitleLabel = 'Service address';
        this.editCTALabel = 'Edit';
        this.editLinkAriaLabel = 'Edit billing address';
        this.billingAddressModifyConsentLabel = 'We\'ll use this address on file as your debit or credit card\'s'
            + ' billing address. If you edit this address, just know that we won\'t update the one on file.';
        this.billingAddressTitleLabel = 'Billing address';
        this.sameAsShippingChkboxLabel = 'Same as my shipping address';
        this.sameAsServiceChkboxLabel = 'Same as my service address';
        this.creditCardBillingAddressLabel = ' Be sure to provide your debit or credit card\'s billing address.';
        this.authenticatedDTVSAddressLabel = "Your changes will be saved only to your DIRECTV account.";
        this.authenticatedBBAddressLabel = "Your changes will be saved only to your Internet account.";
        this.authenticatedAddressDescriptionLabel = "If your wireless billing address has changed,\n    be sure to update it after you submit your order.";
        this.cardBillingAddressLabel = 'Card\'s billing address';
        this.newBBexistingDTVNowInfoMessage = "<strong>Your changes will be saved only to your Internet account.</strong>\n    If your AT&T TV billing address has changed, be sure to update it after you submit your order.";
        this.existingBBNEWDTVNMessage = "<strong>Your changes will be saved only to your AT&T TV account.</strong>\n    If your Internet billing address has changed, be sure to update it after you submit your order.";
        this.rsnFeeCalculationFailureInfo = "We were unable to determine your monthly Regional Sports Network (RSN) fee\n    which is based on your billing address.\n    <br/>\n    <br/>\n    Your RSN fee, currently up to $8.49/mo. and subject to change, will be reflected on your first bill.";
        this.rsnFeeModalBtnText = 'Got it';
        this.rsnFeeModalHeading = 'Before you continue...';
        this.smbBusinessAddressTitleLabel = 'Business address';
        this.smbEditBusinessAddressTitleLabel = 'Edit Business address';
        this.smbSameAsBusinessAddressChkboxLabel = 'Copy from business address';
        this.rewardPromoLabel = "Make sure your billing address matches the one we have on file for\n    your current service. It needs to match so that you qualify for the offers in your cart";
        this.e911ServiceAddressInfo = 'This is the E911 service address listed for your business.';
        this.seeDetailsLabel = ' See details';
    }
    return AddressDetailsPanelCms;
}());
exports.AddressDetailsPanelCms = AddressDetailsPanelCms;
//# sourceMappingURL=addressDetailsPanel.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/panels/AddressDetailsPanel/addressDetailsPanel.cms.js
// module id = 1986
// module chunks = 8